export default "__VITE_ASSET__oXcFSYQo__"